import styled from 'styled-components'

const conditionShadow = props => {
  return props.noShadow
    ? '0 8px 20px 0 rgba(0, 0, 0, 0)'
    : '0 8px 20px 0 rgba(113, 128, 246, 0.1)'
}

export default styled.div`
  &.card-image-box {
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: ${props => conditionShadow(props)};
    background-color: #ffffff;
    transition: all 0.3s ease-in;
    height: 100%;
    @media only screen and (max-width: 992px) {
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
      padding: 15px;
    }
    &:hover {
      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
    }

    img {
      &.card-image {
        padding: ${props => (props.noFluid ? '24px 0 0 0' : 0)};
        width: ${props => (props.noFluid ? '120px' : '100%')};
        height: ${props => (props.noFluid ? '120px' : 'auto')};
        display: block;
        margin: ${props => (props.noFluid ? '0 auto' : 'unset')};
      }
    }
    .title {
      font-family: 'Open Sans';
      font-size: 18px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #333333;
      margin-bottom: 10px;
      display: block;
      white-space: normal;
      &.top {
        margin-top: 30px;
      }
    }

    .text {
      padding: 23px;
      width: 100%;
      display: block;
      white-space: normal;

      .desc {
        font-family: 'Open Sans';
        font-size: 18px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: center;
        color: #888888;
        white-space: normal;
      }
    }
  }
`
